import Footers from './footers';
import Headers from './headers';
import IntroScreen from './IntroScreen';

export default {
  Footers,
  Headers,
  IntroScreen,
};
